import { c as _c } from "react-compiler-runtime";
import { StyledTable } from './StyledTableComponents';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultTableComponent = t0 => {
  const $ = _c(7);
  const {
    children,
    requiredTableProps,
    zebraStripe: t1,
    frozenOffsets,
    condensed: t2,
    dataDensity
  } = t0;
  const zebraStripe = t1 === undefined ? false : t1;
  const condensed = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== children || $[1] !== condensed || $[2] !== dataDensity || $[3] !== frozenOffsets || $[4] !== requiredTableProps || $[5] !== zebraStripe) {
    t3 = /*#__PURE__*/_jsx(StyledTable, Object.assign({
      bordered: true,
      condensed: condensed,
      dataDensity: dataDensity,
      flush: true,
      responsive: false
    }, requiredTableProps, {
      zebraStripe: zebraStripe,
      frozenOffsets: frozenOffsets,
      children: children
    }));
    $[0] = children;
    $[1] = condensed;
    $[2] = dataDensity;
    $[3] = frozenOffsets;
    $[4] = requiredTableProps;
    $[5] = zebraStripe;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};